import React, { useCallback, useEffect, useState } from "react";
import { getAboutStructure } from "../../api/about";
import DetailSection from "../../components/DetailSection";

const OfficeStructure = () => {
  const [pageData, setPageData] = useState(null);

  const getData = useCallback(
    () =>
      getAboutStructure()
        .then((res) => setPageData(res))
        .catch((err) => console.log(err)),
    [setPageData]
  );

  useEffect(() => {
    getData();
  }, [getData]);

  return (
    <>
      <DetailSection
        bgImg="/images/hero-image.jpeg"
        pageTitle="เกี่ยวกับสำนักงาน"
        headerTitle={pageData?.title ?? "โครงสร้างสำนักงาน"}
        image={pageData?.topimage?.path}
        alt={pageData?.topimage?.altText}
        content={pageData?.content ?? ""}
      />
    </>
  );
};

export default OfficeStructure;
